"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.222 5.04c1.075-.916 2.715-.141 2.715 1.26v11.4c0 1.401-1.639 2.175-2.715 1.26l-3.578-3.045H4.649A1.65 1.65 0 0 1 3 14.263V9.737c0-.91.736-1.653 1.649-1.653h1.995zm1.315 1.26a.248.248 0 0 0-.407-.194L7.355 9.318a.7.7 0 0 1-.454.167H4.65a.25.25 0 0 0-.249.253v4.525a.25.25 0 0 0 .249.252H6.9a.7.7 0 0 1 .454.167l3.774 3.211a.248.248 0 0 0 .408-.194zm3.768 2.955a.7.7 0 0 1 .99 0l1.755 1.755 1.755-1.755a.7.7 0 1 1 .99.99L19.04 12l1.755 1.755a.7.7 0 1 1-.99.99L18.05 12.99l-1.755 1.755a.7.7 0 0 1-.99-.99L17.06 12l-1.755-1.755a.7.7 0 0 1 0-.99",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=UnmuteIcon24.js.map